import React from "react";

import ShimmerLoader from "../../../Common/ShimmerLoader";

import { usePlacements } from "../hooks";

import { PlacementCard } from "./components/PlacementCard";

import "./Placements.css";

const PlacementsPage: React.FC = () => {
  const { functions, values, loading } = usePlacements();

  return (
    <div className="page-content">
      <div className="placements-page">
        {/* Header */}
        <div className="placements-header">
          <div className="placements-header__text">
            <h1 className="placements-header__title">Placements</h1>
            <p className="placements-header__subtitle">Global placement configuration and control</p>
          </div>
        </div>

        {/* Body */}
        {loading.listLoading ? (
          <ShimmerLoader type="table" rows={4} />
        ) : values.placements.length > 0 ? (
          <div className="placements-grid">
            {values.placements.map((placement) => (
              <PlacementCard
                key={placement.id}
                placement={placement}
                onSave={functions.savePlacementConfig}
                saveLoading={loading.saveLoading === placement.id}
              />
            ))}
          </div>
        ) : (
          <div className="placements-empty">
            <p>No placements found.</p>
          </div>
        )}

        {values.error && (
          <div className="placements-error">
            <p>{values.error}</p>
          </div>
        )}
      </div>

    </div>
  );
};

export default PlacementsPage;
